import {
  isAndroidPlatform,
  isCapacitorPlatform,
} from "@src/appV2/lib/utils/capacitor/platformUtils";
import { setStatusBarStyle } from "@src/appV2/NativeAdapters/statusBar.adapter";
import { useEffect } from "react";

export function useRedesignStatusBarAppearance() {
  useEffect(() => {
    if (!isCapacitorPlatform() || isAndroidPlatform()) {
      return undefined;
    }

    void setStatusBarStyle("Light");

    return () => {
      void setStatusBarStyle("Dark");
    };
  }, []);
}
